<template>
  <div class="forms">
    <SessionStatus formName="refundRequest" v-if="submitted" v-bind:submissionId="submissionId" display="true" fieldsToFilter="barcode_" @resetEnquiry="resetEnquiry" />
    <Submitted v-if="submitted" @resetEnquiry="resetEnquiry" />
    <TheRefundRequestForm v-else @submitEnquiry="submitEnquiry" />
  </div>
</template>

<script>
import SessionStatus from '@/components/session/SessionStatus.vue'
import Submitted from "@/components/refundRequest/Submitted.vue";
import TheRefundRequestForm from "@/components/refundRequest/TheRefundRequestForm.vue";

export default {
  name: 'TheRefundRequest',
  components: {
    TheRefundRequestForm,
    Submitted,
    SessionStatus
  },
  data: function() {
    return {
      submitted: false,
      submissionId: ''
    }
  },
  methods: {
    submitEnquiry: function(result) {
      this.submitted = result.response == 'OK';
      this.submissionId = result.submissionId;
      scroll(0, 0);
    },
    resetEnquiry: function() {
      this.submitted = false;
      scroll(0, 0);
    }
  }
}
</script>

